import { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import ROUTES from '../../const/routes';
import { environment } from '../../environments/environment';
import { useAuthProvider } from '../../hooks/useAuthProvider';
import { AuthenticatedApp } from '../authenticatedApp';
import { AuthenticationPage } from '../authentication';
import SignInAndRedirect from '../authentication/SignInAndRedirect';
import Chatbot from '../chatbot/Chatbot';
import { DatadogRum } from '../datadog-rum';

export function App() {
  const location = useLocation();

  const isChatbotActivated = !environment.production;

  useEffect(() => {
    //On route change we reload medallia script updatePage (based on https://docs.medallia.com/en/medallia-digital/medallia-digital-web/architecture/single-page-architecture-spa-compatibility-guidelines)
    if (
      window.KAMPYLE_ONSITE_SDK &&
      typeof window.KAMPYLE_ONSITE_SDK.updatePageView === 'function'
    ) {
      window.KAMPYLE_ONSITE_SDK.updatePageView();
    }
  }, [location]);

  const isAuthenticated = useAuthProvider();

  return (
    <>
      {isChatbotActivated && <Chatbot />}
      <Routes>
        <Route
          path="/personal-offer/authentication"
          element={<AuthenticationPage />}
        />
        {ROUTES.map(({ Component, path }) => {
          return (
            <Route
              key={path}
              path={path}
              element={
                <DatadogRum
                  applicationId={environment.datadogApplicationId}
                  clientToken={environment.datadogClientToken}
                  sessionReplaySampleRate={
                    environment.datadogEnv === 'prod' ? 20 : 0
                  }
                >
                  {isAuthenticated ? (
                    <AuthenticatedApp Component={Component} />
                  ) : (
                    <SignInAndRedirect />
                  )}
                </DatadogRum>
              }
            />
          );
        })}
      </Routes>
    </>
  );
}

export default App;
